import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

import useSamlValidate from '@/features/saml/api/hooks/useSamlValidate';

const Saml = () => {
  const [searchParams, ,] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const initialized = useRef(false);

  const { mutateAsync } = useSamlValidate();
  useEffect(() => {
    const validateLogin = async () => {
      await mutateAsync({ token });
    };

    if (!initialized.current) {
      initialized.current = true;

      void validateLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadingWrapper>
      <CircularProgress />
    </LoadingWrapper>
  );
};

export default Saml;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
